<template>
  <footer class="app-footer" role="contentinfo">
    <div class="app-footer-inner">
      <div class="footer-content footer-between">
        <div class="footer-left">
          <span class="footer-text">Grupo Agrovin</span>
        </div>
        <div class="footer-right">
          <a class="agrovin-link" href="https://agrovin.com" target="_blank" rel="noopener noreferrer">agrovin.com</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>

<style scoped>
/* A full-bleed black stripe while keeping inner content aligned with the page */
.app-footer {
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw; /* force full-bleed on wide containers */
  margin-right: -50vw;
  width: 100vw;
  background: #000;
  color: #fff;
  box-sizing: border-box;
}
.app-footer-inner {
  max-width: 2400px; /* duplicado: ampliar el ancho interno del footer */
  margin: 0 auto;
  padding: 24px 16px; /* vertical padding duplicado para mayor grosor */
  min-height: 48px; /* asegurar un grosor mínimo visual */
}
.footer-content {
  display: flex;
  align-items: center;
  justify-content: space-between; /* separate left and right */
  gap: 8px;
}

/* Helper explícito para layouts 'between' (usa junto a .footer-content) */
.footer-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

/* En pantallas pequeñas apilar el contenido del footer */
@media (max-width: 600px) {
  .footer-content.footer-between,
  .footer-between {
    flex-direction: column;
    align-items: center; /* centrar los items en columna */
    gap: 10px;
  }
  /* Hacer que ambos bloques ocupen toda la línea y centrar su contenido */
  .footer-left,
  .footer-right {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .footer-right {
    align-self: center;
  }
}
.footer-left { display: flex; align-items: center; }
.footer-right { display: flex; align-items: center; }
.footer-text {
  font-size: 16px; /* aumentado */
  opacity: 0.95;
  font-family: 'WorkSans', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-weight: 400;
}

/* Load WorkSans Regular (TTF) from assets - please add src/assets/fonts/WorkSans-Regular.ttf */
@font-face {
  font-family: 'WorkSans';
  src: url('@/assets/fonts/WorkSans-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

/* WorkSans SemiBold for emphasis (uses the TTF file at src/assets/fonts/WorkSans-SemiBold.ttf) */
@font-face {
  font-family: 'WorkSans';
  src: url('@/assets/fonts/WorkSans-SemiBold.ttf') format('truetype');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@media (max-width: 768px) {
  .app-footer-inner { padding: 20px 12px; }
  .footer-text { font-size: 12px; }
}

.agrovin-link {
  color: #99172A; /* corporate red */
  font-family: 'WorkSans', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-weight: 600; /* SemiBold */
  font-size: 18px; /* aumentado */
  text-decoration: none;
}
</style>
